import { withInstall } from '../utils';
import _Overlay from './Overlay';
export var Overlay = withInstall(_Overlay);
export default Overlay;